import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './FoldVideo.module.css';


function FoldVideo() {

    return (
        <>
            <div className={styles.foldVideoContainer}>
                <video autoPlay={true} muted={true} loop={true} className={styles.foldVideo} >
                    <source src="./video/better_vid.mp4" type="video/mp4"></source>
                </video>
            </div>
            <div className={styles.foldGradient}></div>
        </>


    );
}

export default FoldVideo;
